import BaseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";
import IUserState from "./models/IUserState";
import UserAction from "./UserAction";
import UserModel from "./models/UserModel";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import UserInfoModel from "./models/UserInfoModel";
import ResponseAuthTokensModel from "stores/shared/models/ResponseAuthTokensModel";
import RicercaPreventivoViewModel from "stores/preventivo/models/RicercaPreventivoViewModel";
//import RegistrationAnonyousModel from "./models/RegistrationAnonymousModel";
export default class UserReducer extends BaseReducer<IUserState> {
    public readonly initialState: IUserState = {
        profile: new UserModel({}),
        responseRegistration: false,
        responseTokenVerification: false,
        responseRegistrationConfirm: false,
        responseRecuperoPassword: false,
        responseTokenRecuperoPassword: false,
        responseCambioPassword: false,
        responseSalvaConsensi: false,
        // responseRegistrationAnonymous: new RegistrationAnonyousModel({})
    };

    public [UserAction.SET_COOKIE_CONSENT_FINISHED](state: IUserState, action: IAction<boolean>): IUserState {
        return {
            ...state,
            profile: {
                ...state.profile,
                isCookieAllowed: action.payload!,
            } as UserModel,
        };
    }

    public [UserAction.REQUEST_USER_LOGIN_FINISHED](
        state: IUserState,
        action: IAction<ResponseAuthTokensModel>
    ): IUserState {
        let accessToken: string = "";
        let refreshToken: string = "";
        let isLogged = false;
        if (action.payload && action.payload!.accessToken && action.payload!.refreshToken) {
            accessToken = action.payload!.accessToken;
            refreshToken = action.payload!.refreshToken;

            isLogged = true;
        }
        sessionStorage.setItem("accessToken", accessToken);
        sessionStorage.setItem("refreshToken", refreshToken);

        return {
            ...state,
            profile: {
                ...state.profile,
                isLogged: isLogged,
                infoEsito: action.payload!.infoEsito,
            } as UserModel,
        };
    }

    public [UserAction.SET_USER_LOGIN_REQUIRED_FINISHED](state: IUserState, action: IAction<boolean>): IUserState {
        const accessToken = sessionStorage.getItem("accessToken");
        const refreshToken = sessionStorage.getItem("refreshToken");
        let isLogged = false;
        if (accessToken && refreshToken) {
            isLogged = true;
        }
        return {
            ...state,
            profile: {
                ...state.profile,
                isLogged: isLogged,
                isLoginRequired: action.payload!,
            } as UserModel,
        };
    }

    public [UserAction.SET_USER_LOGIN_FINISHED](state: IUserState, action: IAction<any>): IUserState {
        const accessToken = sessionStorage.getItem("accessToken");
        const refreshToken = sessionStorage.getItem("refreshToken");
        let isLogged = false;
        if (accessToken && refreshToken) {
            isLogged = true;
        }
        return {
            ...state,
            profile: {
                ...state.profile,
                isLogged: isLogged,
            } as UserModel,
        };
    }

    public [UserAction.SET_USER_LOGOUT_FINISHED](state: IUserState, action: IAction<ResponseEsitoModel>): IUserState {
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("refreshToken");
        return {
            ...state,
            profile: {
                ...state.profile,
                username: "",
                isLogged: false,
            } as UserModel,
        };
    }

    public [UserAction.REQUEST_USER_REGISTRATION_FINISHED](
        state: IUserState,
        action: IAction<ResponseEsitoModel>
    ): IUserState {
        return {
            ...state,
            responseRegistration: action.payload!.esito,
        };
    }

    public [UserAction.REQUEST_VERIFICA_TOKEN_FINISHED](
        state: IUserState,
        action: IAction<ResponseEsitoModel>
    ): IUserState {
        return {
            ...state,
            responseTokenVerification: action.payload!.esito,
        };
    }

    public [UserAction.REQUEST_USER_REGISTRATION_CONFIRM_FINISHED](
        state: IUserState,
        action: IAction<ResponseEsitoModel>
    ): IUserState {
        return {
            ...state,
            responseRegistrationConfirm: action.payload!.esito,
        };
    }

    public [UserAction.REQUEST_GET_INFO_UTENTE_FINISHED](
        state: IUserState,
        action: IAction<UserInfoModel>
    ): IUserState {
        return {
            ...state,
            profile: {
                ...state.profile,
                nome: action.payload!.nome,
                cognome: action.payload!.cognome,
                email: action.payload!.email,
            } as UserModel,
        };
    }

    public [UserAction.REQUEST_USER_DELETE_FINISHED](
        state: IUserState,
        action: IAction<ResponseEsitoModel>
    ): IUserState {
        return {
            ...state,
            profile: {
                ...state.profile,
                username: "",
                isLogged: false,
                nome: "",
                cognome: "",
                email: "",
            } as UserModel,
        };
    }

    public [UserAction.REQUEST_USER_RECUPERO_PASSWORD_FINISHED](
        state: IUserState,
        action: IAction<ResponseEsitoModel>
    ): IUserState {
        return {
            ...state,
            responseRecuperoPassword: action.payload!.esito,
        };
    }

    public [UserAction.REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD_FINISHED](
        state: IUserState,
        action: IAction<ResponseEsitoModel>
    ): IUserState {
        return {
            ...state,
            responseTokenRecuperoPassword: action.payload!.esito,
        };
    }

    public [UserAction.REQUEST_USER_RINVIO_REGISTRATION_FINISHED](
        state: IUserState,
        action: IAction<ResponseEsitoModel>
    ): IUserState {
        return {
            ...state,
            responseRegistration: action.payload!.esito,
        };
    }

    public [UserAction.REQUEST_USER_CAMBIO_PASSWORD_FINISHED](
        state: IUserState,
        action: IAction<ResponseEsitoModel>
    ): IUserState {
        return {
            ...state,
            responseCambioPassword: action.payload!.esito,
        };
    }

    /*   public [UserAction.REQUEST_USER_REGISTRATION_ANONYMOUS_FINISHED ](
        state: IUserState,
        action: IAction<RegistrationAnonyousModel>
    ): IUserState {
        return {
            ...state,
             responseRegistrationAnonymous: {
                 idUtente: action.payload!.idUtente,
             } as RegistrationAnonyousModel
            
        };
    } */

    public [UserAction.REQUEST_SET_USER_REGISTRATION_MODEL_FINISHED](
        state: IUserState,
        action: IAction<RicercaPreventivoViewModel>
    ): IUserState {
        return {
            ...state,
            profile: {
                ...state.profile,
                email: action.payload!.informazioniUtente.email,
                privacy: action.payload!.informazioniUtente.privacy,
                idUtente: action.payload!.informazioniUtente.idUtente,
            } as UserModel,
        };
    }

    public [UserAction.REQUEST_SAVE_CONSENSI_USER_FINISHED](
        state: IUserState,
        action: IAction<ResponseEsitoModel>
    ): IUserState {
        console.log("reducer");
        return {
            ...state,
            responseSalvaConsensi: action.payload!.esito,
        };
    }
}
